import React from 'react';

var renderElement = function renderElement(element, props, editor, next) {
  if (!element) return next();
  if (typeof element === 'function') return element(props, editor, next);
  return React.createElement(element, props.attributes, props.children);
};

export default (function () {
  var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'node';
  return function (props, editor, next) {
    return props[prop] ? renderElement(elements[props[prop].type], props, editor, next) : next();
  };
});